import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import AbstractDropdownView from 'common/components/AbstractDropdownView';
import ModalApproveDecline from "../ModalApproveDecline";
import MultipleTooltip from "../MultipleTooltip";
import textSuggestionsIcon from './Write.svg';
import styles from './styles.module.scss';

const ButtonTextSuggestions = ({
                                 fieldName,
                                 currentFieldValue,
                                 textSuggestionsArray = [],
                                 setFieldValue,
                                 menuPosition = 'up',
                               }) => {
  const [openModalApproveDecline, setOpenModalApproveDecline] = useState(false);
  const [value, setValue] = useState('');

  return (
    <div className={styles.textSuggestionsInteraction}>
      <AbstractDropdownView
        subPath={`textSuggestions-${fieldName}`}
        closeOnOutsideClick={!openModalApproveDecline}
        triggerContent={({toggleDropdown, triggerProps}) => (
          <div onClick={toggleDropdown} {...triggerProps}>
            <MultipleTooltip
              id={`textSuggestions-${fieldName}`}
              customIconClassName={styles.triggerButton}
              label={'טקסט מנחה'}
              icon={textSuggestionsIcon}
            />
          </div>
        )}
        customContainerClassName={styles.textSuggestionsMenu}
        dropdownContent={({itemProps}) => (
          <>
            <ModalApproveDecline
              isOpen={openModalApproveDecline}
              message={'שימו לב, קיים טקסט בשדה זה. איזו פעולה תרצו לבצע?'}
              customButtons={
                <div className={styles.buttonsContainer}>
                  <button
                    className={styles.buttonDecline}
                    onClick={() => {
                      setOpenModalApproveDecline(false)
                    }}
                  >
                    ביטול
                  </button>
                  <button
                    className={styles.buttonApprove}
                    onClick={() => {
                      setFieldValue(fieldName, value);
                      setOpenModalApproveDecline(false);
                    }}
                  >
                    החלף
                  </button>
                  <button
                    className={styles.buttonAppend}
                    onClick={() => {
                      setFieldValue(fieldName, `${currentFieldValue} \n ${value}`);
                      setOpenModalApproveDecline(false);
                    }}
                  >
                    הוסף
                  </button>
                </div>
              }
            />
            <div className={classnames(styles.textSuggestionsPopup, {[styles.menuPositionDown]: menuPosition === 'down'})}>
              <div className={styles.header}>בחירת טקסט מנחה:</div>
              {textSuggestionsArray.map((item, index) => {
                return (
                  <div
                    className={styles.option}
                    onClick={() => {
                      if (Boolean(currentFieldValue)) {
                        setOpenModalApproveDecline(true)
                        setValue(`${item.value}`)
                      } else {
                        setFieldValue(fieldName, `${item.value}`)
                      }
                    }}
                    {...itemProps[index]}
                  >
                    {item.label}
                  </div>
                )
              })}
            </div>
          </>
        )}
      />
    </div>
  );
};

ButtonTextSuggestions.propTypes = {
  fieldName: PropTypes.string,
  currentFieldValue: PropTypes.string,
  textSuggestionsArray: PropTypes.array,
  setFieldValue: PropTypes.func,
  menuPosition: PropTypes.string,
};

export default ButtonTextSuggestions;
